// 3rd-party modules
import { Skeleton, Typography } from "antd";
import { useEffect, useState } from "react";

// project modules
import { formatMoney } from "../../helpers/objectHelper";
import { apiCall } from "../../helpers/apiHelper";
import Loader from "../shared/loader";
import useTranslation from "../../hooks/TranslationContext";

//apis
import * as SmsPanelApi from '../../apis/smsPanelApi';

//models
import { SmsAccountBalanceModel } from "../../models/smsAccountBalance";

export default function SmsPanelRemainingBalance() {
  const { t } = useTranslation();

  const [accountBalance, setAccountBalance] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();

  useEffect(() => {
    getAccountBalanceAsync();
  }, []);

  const getAccountBalance = async (abortSignal?: AbortSignal) => {
    const response = await apiCall(SmsPanelApi.getAccountBalance(abortSignal));

    if (response.success && response.data?.value) {
      const data = SmsAccountBalanceModel.toClass(response.data?.value);
      return Number(data.balance) || 0;
    }

    return 0;
  };

  const getAccountBalanceAsync = async () => {
    setLoading(true);
    setAccountBalance(await getAccountBalance(abortController.signal));
    setLoading(false);
  }

  return(
    <>
      {loading && <Loader/>}
      <Typography.Title level={3}>
        {
          loading ?
          <Skeleton.Input active />
          :
          formatMoney(accountBalance,t("rial"))
        }
      </Typography.Title>
      <Typography.Text>{t("remaining-balance")}</Typography.Text>
    </>
  )
}
